
  <ng-progress id="myProgress" [direction]="'ltr+'" [speed]="200" [trickleSpeed]="300" [debounceTime]="0" 
  [meteor]="true" [spinner]="true" spinnerPosition="right" [thick]="false" [fixed]="true" [min]="8"
  [max]="100" [ease]="'linear'"  [color]="'#333'"></ng-progress>
  
  <!-- //<mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner> -->

